var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "drop-shadow afterSave", attrs: { "max-width": "450" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("title")) + " "),
          _c("w-spacer"),
          _c("w-fa", {
            staticClass: "close-button",
            attrs: { icon: "times", right: "" },
            on: {
              click: function ($event) {
                return _vm.cancel()
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            { attrs: { "no-margin": "" } },
            [
              _c("w-input-number", {
                ref: "input",
                style: { width: "100%" },
                attrs: {
                  decimals: 2,
                  fancy: "",
                  label: _vm.$ct("label"),
                  autofocus: "",
                },
                model: {
                  value: _vm.discount,
                  callback: function ($$v) {
                    _vm.discount = $$v
                  },
                  expression: "discount",
                },
              }),
            ],
            1
          ),
          _c(
            "w-row",
            { staticClass: "mt", attrs: { "no-margin": "" } },
            [
              _c("w-checkbox", {
                attrs: { label: _vm.$ct("full-document") },
                model: {
                  value: _vm.skipNonEmptyDiscount,
                  callback: function ($$v) {
                    _vm.skipNonEmptyDiscount = $$v
                  },
                  expression: "skipNonEmptyDiscount",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.apply()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("apply")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }